import React from 'react';
import { Carousel, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import ImageCard from '../common/ImageCard';
import SmartImage from '../common/SmartImage';

const ExploreBanner = ({ items = [], sideItems = [], loading = false }) => {
  const navigate = useNavigate();

  // Fallback items if none provided
  const carouselItems = items.length > 0 ? items : [
    {
      id: 1,
      title: "热帖神评送好礼！",
      description: "回复评论，收集点赞",
      image: "https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?q=80&w=2564&auto=format&fit=crop",
      color: "#1890ff"
    },
    {
      id: 2,
      title: "协创者第一届大赛",
      description: "立即参与，赢取大奖",
      image: "https://images.unsplash.com/photo-1550745165-9bc0b252726f?q=80&w=2670&auto=format&fit=crop",
      color: "#722ed1"
    }
  ];

  const sideCards = sideItems.length > 0 ? sideItems : [
    {
      id: 's1',
      tag: '官方',
      title: '运营官自荐',
      description: '内容内容内容内容内容内容内容内容内容内容内容内容',
      author: { name: 'Jackson', avatar: '' },
      likes: '2.5W',
      image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?q=80&w=2670&auto=format&fit=crop',
      bgColor: 'bg-blue-400'
    },
    {
      id: 's2',
      tag: '官方',
      title: '运营官自荐',
      description: '内容内容内容内容内容内容内容内容内容内容内容内容',
      author: { name: 'Jackson', avatar: '' },
      likes: '2.5W',
      image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=2670&auto=format&fit=crop',
      bgColor: 'bg-pink-400'
    }
  ];

  const handleCarouselClick = (item) => {
    // Navigate to competition detail page if id exists
    if (item.id) {
      navigate(`/explore/proposals/${item.id}`);
    }
  };

  const handleSideCardClick = (card) => {
    // Navigate to post detail page if id exists
    if (card.id) {
      navigate(`/explore/friends/${card.id}`);
    }
  };

  if (loading) {
    return (
      <div className="flex flex-nowrap items-start gap-6 overflow-x-auto">
        {/* Main Carousel Skeleton */}
        <div className="w-full max-w-[416px] h-[268px] flex-shrink-0 rounded-lg overflow-hidden relative bg-gray-200 flex flex-col items-center justify-center gap-4">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
          <span className="text-gray-500 text-sm">加载中...</span>
        </div>

        {/* Side Cards Skeleton */}
        <div className="w-full max-w-[416px] flex-shrink-0 flex flex-nowrap gap-6 overflow-x-auto">
          {[1, 2].map((i) => (
            <div 
              key={i} 
              className="w-[196px] h-[268px] rounded-lg overflow-hidden relative bg-gray-200 flex items-center justify-center flex-shrink-0"
            >
              <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-nowrap items-start gap-6 overflow-x-auto">
      {/* Main Carousel */}
      <div className="w-full max-w-[416px] h-[268px] flex-shrink-0 rounded-lg overflow-hidden relative group cursor-pointer">
        <Carousel autoplay className="h-full">
          {carouselItems.map(item => (
            <div 
              key={item.id} 
              className="h-[268px] relative"
              onClick={() => handleCarouselClick(item)}
            >
              <SmartImage 
                src={item.image} 
                alt={item.title} 
                className="w-full h-full object-cover" 
                fallbackMaxLength={26}
              />
              <div className="absolute bottom-0 left-0 w-full h-1/5 bg-gradient-to-t from-black/90 to-transparent pointer-events-none"></div>
              <h2 
                className="absolute left-[18px] top-[224px] w-[391px] h-[17px] text-[16px] leading-[21px] text-justify font-normal text-white font-['OPPOSans']"
              >
                {item.title}
              </h2>
            </div>
          ))}
        </Carousel>
      </div>

      {/* Side Cards */}
      <div className="w-full max-w-[416px] flex-shrink-0 flex flex-nowrap gap-6 overflow-x-auto">
        {sideCards.slice(0, 2).map(card => (
          <ImageCard
            key={card.id}
            title={card.title}
            description={card.description}
            coverImage={card.image}
            author={card.author}
            likes={card.likes}
            is_liked={card.is_liked}
            width="w-[196px]"
            className="flex-shrink-0"
            onClick={() => handleSideCardClick(card)}
            renderBadge={() => (
              <div className="absolute top-2 left-2 bg-[#4C78FF] text-white text-[14px] font-black px-[10px] py-[4px] rounded shadow-[0_4px_8px_rgba(0,0,0,0.16)] flex items-center justify-center leading-none h-[24px] -skew-x-12 tracking-wider">
                {card.tag}
              </div>
            )}
          />
        ))}
      </div>
    </div>
  );
};

export default ExploreBanner;
